export const state = {
  economies: [],
  isLoading: false,
  totalRecords: 0,
  economyPerPage: 10000,
  activePage: 1,
};
